import style from '../modules/HomePage.module.scss';

export const HomePage = () => (
  <h1 className={style.visuallyHidden}>Product Catalog</h1>
);
